import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { toast } from 'react-toastify';
import { UserSummaryType } from '../../../../../../../../../api/types/user/user-summary.type';
import { PermissionGroupUserDetails } from '../../../../../../../../../api/types/settings/permissions/permission-group-details.type';
import { addUsersToPermissionGroupOperation } from '../../../operations/add-users-to-permission-group-operation';
import { AddPermissionGroupUsersDialogContent } from '../components/add-permission-group-users-dialog-content';

interface AddPermissionGroupUsersDialogProps {
  visible: boolean;
  groupId: number;
  existingUsers: PermissionGroupUserDetails[];
  onHide: () => void;
  onUsersAdded: () => void;
}

export const AddPermissionGroupUsersDialog: React.FC<
  AddPermissionGroupUsersDialogProps
> = ({ visible, groupId, existingUsers, onHide, onUsersAdded }) => {
  const [selectedUsers, setSelectedUsers] = useState<UserSummaryType[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      setSelectedUsers([]);
      setLoading(false);
    }
  }, [visible]);

  const handleApprove = async (
    users: UserSummaryType[],
    setApproveLoading: (isLoading: boolean) => void,
  ) => {
    if (users.length === 0) {
      toast.warn('יש לבחור לפחות משתמש אחד');
      return;
    }

    const existingUserIds = new Set(existingUsers.map((user) => user.userId));
    const newUserIds = users
      .map((user) => user.id)
      .filter((userId) => !existingUserIds.has(userId));

    if (newUserIds.length === 0) {
      toast.warn('כל המשתמשים שנבחרו כבר שייכים לקבוצה');
      return;
    }

    await addUsersToPermissionGroupOperation(
      groupId,
      newUserIds,
      (isLoading) => {
        setLoading(isLoading);
        setApproveLoading(isLoading);
      },
      () => {
        onUsersAdded();
        onHide();
      },
    );
  };

  return (
    <Dialog
      header="הוספת משתמשי מנהלה לקבוצה"
      visible={visible}
      style={{
        height: '100vh',
        width: '800px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      onHide={onHide}
      dismissableMask
      draggable={false}
      resizable={false}
    >
      <AddPermissionGroupUsersDialogContent
        selectedUsers={selectedUsers}
        loading={loading}
        onSelectedUsersChange={setSelectedUsers}
        onApprove={handleApprove}
        onHide={onHide}
      />
    </Dialog>
  );
};
